import React from "react";

export function renderWithBoldHelper(t, key, placeholderKey, value) {
  const marker = "__BOLD__";
  const raw = t(key, { [placeholderKey]: marker });
  const parts = raw.split(marker);

  return (
    <>
      {parts[0]}
      <span className="fw-bold">{value}</span>
      {parts[1]}
    </>
  );
}
